import React, { Component } from 'react';
import { Layout, Row, Col, Input,  Icon } from 'antd';
import img from '../../assets/img/At the office-pana 1.png';
import AgencyContent from './Admin/AgencyContent';
import BrokerContent from './Admin/BrokerContent';
import ClientContent from './Admin/ClientContent';
import FinacecContent from './Admin/FinacecContent';
import InvoiceAdj from './Admin/InvoiceAdj';
import ManageInvitationsContent from './Admin/ManageInvitationsContent';
import ReportsContent from './Admin/ReportsContent';
import TaxProfileContent from './Admin/TaxProfileContent';
import AgReportsContent from './Agency/AgReportsContent';
import AgencyProfileContent from './Agency/AgencyProfileContent';
import AgencyEnrollmentsContent from './Agency/AgencyEnrollmentsContent';
import AgencyPlansContent from './Agency/AgencyPlansContent';
import BookOfBusinessContent from '../HelpMenu/Agency/BookOfBusiness_Content';
import BrokersContent from './Agency/BrokersContent';
import BroReportsContent from './Broker/BroReportsContent';
import BrokerBookOfBusinessContent from './Broker/BrokerBookOfBusinessContent';
import BrokerEnrollmentsContent from './Broker/BrokerEnrollmentsContent';
import BrokerPlansContent from './Broker/BrokerPlansContent';
import BrokerprofileContent from './Broker/BrokerProfileContent';
import { Link } from 'react-router-dom';
const { Content } = Layout;
class Help extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialload: true,
            onmenuload: "",
            Admin: [{ name: 'Brokers', icon: 'fa fa-users' },
            { name: 'Agencies', icon: 'fa fa-suitcase' },
            { name: 'Carrier', icon: 'fa fa-university' },
            { name: 'Finance', icon: 'fa fa-bar-chart' },
            { name: 'Reports', icon: 'fa fa-file' },
            { name: 'Manage Invitations', icon: 'fa fa-envelope' },
            { name: 'Tax Profile', icon: 'fa fa-calculator' },
            ],
            Admin1: [{ name: 'Brokers', icon: 'fa fa-users' },
            { name: 'Agencies', icon: 'fa fa-suitcase' },
            { name: 'Carrier', icon: 'fa fa-university' },
            { name: 'Finance', icon: 'fa fa-bar-chart' },
            { name: 'Reports', icon: 'fa fa-file' },
            { name: 'Manage Invitations', icon: 'fa fa-envelope' },
            { name: 'Tax Profile', icon: 'fa fa-calculator' },
            ],
            Broker: [{ name: 'Broker Profile', icon: 'fa fa-id-card' },
            { name: 'Broker Enrollment', icon: 'fa fa-suitcase' },
            { name: 'Broker Plans', icon: 'fa fa-tag' },
            { name: 'Our Book', icon: 'fa fa-industry' },
            { name: 'Reports', icon: 'fa fa-file' },
            ],
            Broker1: [{ name: 'Broker Profile', icon: 'fa fa-id-card' },
            { name: 'Broker Enrollment', icon: 'fa fa-suitcase' },
            { name: 'Broker Plans', icon: 'fa fa-tag' },
            { name: 'Our Book', icon: 'fa fa-industry' },
            { name: 'Reports', icon: 'fa fa-file' },
            ],
            Agency: [{ name: 'Agency Profile', icon: 'fa fa-id-card' },
            { name: 'Agency Enrollment', icon: 'fa fa-suitcase' },
            { name: 'Agency Brokers', icon: 'fa fa-users' },
            { name: 'Agency Plans', icon: 'fa fa-tag' },
            { name: 'Our Book', icon: 'fa fa-industry' },
            { name: 'Reports', icon: 'fa fa-file' },
            ],
            Agency1: [{ name: 'Agency Profile', icon: 'fa fa-id-card' },
            { name: 'Agency Enrollment', icon: 'fa fa-suitcase' },
            { name: 'Agency Brokers', icon: 'fa fa-users' },
            { name: 'Agency Plans', icon: 'fa fa-tag' },
            { name: 'Our Book', icon: 'fa fa-industry' },
            { name: 'Reports', icon: 'fa fa-file' },
            ],
        }
    }
    Search = (type, value) => {
        if (type === "admin") {
            this.setState({
                Admin: this.state.Admin1.filter(o =>
                    Object.keys(o).some(k =>
                        String(o[k])
                            .toLowerCase()
                            .includes(value.target.value)
                    )
                )
            })
        }
        if (type === "broker") {
            this.setState({
                Broker: this.state.Broker1.filter(o =>
                    Object.keys(o).some(k =>
                        String(o[k])
                            .toLowerCase()
                            .includes(value.target.value)
                    )
                )
            })
        }
        if (type === "agency") {
            this.setState({
                Agency: this.state.Agency1.filter(o =>
                    Object.keys(o).some(k =>
                        String(o[k])
                            .toLowerCase()
                            .includes(value.target.value)
                    )
                )
            })
        }
    }
    HelpmenuClick = (name) => {
        this.setState({
            initialload: false,
            onmenuload: name
        })
    }
    back = () => {
        this.setState({
            initialload: true,
            onmenuload: ""
        })
    }
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        const { onmenuload } = this.state;
        let help, helpConent;
        switch (role) {
            case "broker":
                switch (onmenuload) {
                    case "Broker Profile":
                        helpConent = <BrokerprofileContent userPermandMasters={this.props.userPermandMasters} />
                        break;
                    case "Broker Enrollment":
                        helpConent = (<BrokerEnrollmentsContent userPermandMasters={this.props.userPermandMasters}></BrokerEnrollmentsContent>)
                        break;
                    case "Broker Plans":
                        helpConent = (<BrokerPlansContent userPermandMasters={this.props.userPermandMasters}></BrokerPlansContent>)
                        break;
                    case "Our Book": helpConent = (<BrokerBookOfBusinessContent userPermandMasters={this.props.userPermandMasters}></BrokerBookOfBusinessContent>)
                        break;
                    case "Reports":
                        helpConent = (<BroReportsContent userPermandMasters={this.props.userPermandMasters}></BroReportsContent>)
                        break;
                    default:
                        break;
                }
                break;
            case "agency":
                switch (onmenuload) {
                    case "Agency Profile":
                        helpConent = (<AgencyProfileContent userPermandMasters={this.props.userPermandMasters}></AgencyProfileContent>)
                        break;
                    case "Agency Enrollment":
                        helpConent = (<AgencyEnrollmentsContent userPermandMasters={this.props.userPermandMasters}></AgencyEnrollmentsContent>)
                        break;
                    case "Agency Brokers":
                        helpConent = (<BrokersContent userPermandMasters={this.props.userPermandMasters}></BrokersContent>)
                        break;
                    case "Agency Plans":
                        helpConent = (<AgencyPlansContent userPermandMasters={this.props.userPermandMasters}></AgencyPlansContent>)
                        break;
                    case "Our Book": helpConent = (<BookOfBusinessContent userPermandMasters={this.props.userPermandMasters}></BookOfBusinessContent>)
                        break;
                    case "Reports":
                        helpConent = (<AgReportsContent userPermandMasters={this.props.userPermandMasters}></AgReportsContent>)
                        break;
                    default:
                        break;
                }
                break;
            default:
                switch (onmenuload) {
                    case "Agencies":
                        helpConent = (<AgencyContent userPermandMasters={this.props.userPermandMasters}></AgencyContent>)
                        break;
                    case "Brokers":
                        helpConent = (<BrokerContent userPermandMasters={this.props.userPermandMasters}></BrokerContent>)
                        break;
                    case 'Carrier':
                        helpConent = (<ClientContent userPermandMasters={this.props.userPermandMasters}></ClientContent>)
                        break;
                    case "Finance":
                        helpConent = (<FinacecContent userPermandMasters={this.props.userPermandMasters}></FinacecContent>)
                        break;
                    case "Reports": helpConent = (<ReportsContent userPermandMasters={this.props.userPermandMasters}></ReportsContent>)
                        break;
                    case "Manage Invitations":
                        helpConent = (<ManageInvitationsContent userPermandMasters={this.props.userPermandMasters}></ManageInvitationsContent>)
                        break;
                    case "Tax Profile":
                        helpConent = (<TaxProfileContent userPermandMasters={this.props.userPermandMasters}></TaxProfileContent>)
                        break;
                    case "Invoice Adjustment":
                        helpConent = (<InvoiceAdj userPermandMasters={this.props.userPermandMasters}></InvoiceAdj>)
                        break;
                    default:
                        break;
                }
                break;
        }
        if (role === "broker") {
            help = (<>
                <Row className='ant-table-wrapper'>
                    <Col sm={12} className='mi_table_title'>
                        Browser Help Topics
                    </Col>
                    <Col sm={12} >
                        <Input.Search onChange={this.Search.bind(this, 'agency')} placeholder="Search" autoComplete={"nope"}  style={{ marginRight: '15px', borderRadius: "12px", paddingBottom: "40px",marginBottom:"15px" }} className="table-search-button"
                            type="text" />
                    </Col>
                </Row>
                <Row style={{ marginBottom: '30px' }}>
                    <Col sm={24}>
                        {this.state.Broker.map(x =>
                            <Col sm={12}>
                                <div className="helpdiv" onClick={() => this.HelpmenuClick(x.name)}>
                                    <p className="mi_acc_header1"><i className={x.icon} /> {x.name}</p>
                                </div>
                            </Col>
                        )}
                    </Col>
                </Row>
            </>)
        } else if (role === "agency") {
            help = (<>
                <Row className='ant-table-wrapper'>
                    <Col sm={12} className='mi_table_title'>
                        Browser Help Topics
                    </Col>
                    <Col sm={12} >
                            <Input.Search onChange={this.Search.bind(this, 'agency')} placeholder="Search" autoComplete={"nope"}  style={{ marginRight: '15px', borderRadius: "12px", paddingBottom: "40px",marginBottom:"15px" }} className="table-search-button"
                            type="text" />
                              </Col>
                </Row>
                <Row style={{ marginBottom: '30px' }}>
                    <Col sm={24}>
                        {this.state.Agency.map(x =>
                            <Col sm={12}>
                                <div className="helpdiv" onClick={() => this.HelpmenuClick(x.name)}>
                                    <p className="mi_acc_header1"><i className={x.icon} /> {x.name}</p>
                                </div>
                            </Col>
                        )}
                    </Col>
                </Row>
            </>)
        } else {
            help = (<>
                <Row className='ant-table-wrapper'>
                    <Col sm={12} className='mi_table_title'>
                        Browser Help Topics
                    </Col>
                    <Col sm={12} >

                              <Input.Search onChange={this.Search.bind(this, 'admin')} placeholder="Search" autoComplete={"nope"}  style={{ marginRight: '15px', borderRadius: "12px", paddingBottom: "40px",marginBottom:"15px" }} className="table-search-button"
                            type="text" />
                     </Col>
                </Row>
                <Row style={{ marginBottom: '30px' }}>
                    {this.state.Admin.map(x =>
                        <Col sm={12}>
                            <div className="helpdiv" onClick={() => this.HelpmenuClick(x.name)}>
                                <p className="mi_acc_header1"><i className={x.icon} /> {x.name}</p>
                            </div>
                        </Col>
                    )}
                </Row>
            </>)
        }
        return (
            this.state.initialload === true ?

                <Content>

                    <div className="mi_main_div">
                        <div className="mi_main1">
                            <div className="mi_box">
                                <Row span={24}>
                                    <Col span={18}>
                                        <h4 className="mi_box_h4">We're here to Help</h4>
                                    </Col>
                                    <Col span={6}>
                                        <img alt="example" style={{ height: '182px', marginTop: '-80px'  }} src={img} />
                                    </Col>
                                </Row>
                            </div>
                            {help}
                        </div></div>
                </Content> : <Content>
                    <div className="mi_main_div">

                        <div className="mi_main1">
                            <div className="mi_box">

                                <Row span={24}>
                                    <Col span={18}>
                                        <h4 className="mi_box_h4">{this.state.onmenuload}</h4>
                                    </Col>
                                    <Col span={6}>
                                        <img alt="example" style={{ height: '150px', marginTop: '-50px' }} src={img} />
                                    </Col>
                                </Row>
                            </div>


                            <u ><Link to="/help"  style={{color:'black'}} onClick={this.back} >
                            <Icon type="arrow-left"/> Back </Link></u>

                            <div>
                                {helpConent}
                            </div>

                        </div></div>
                </Content>
        )
    }
}
export default Help;
